import config from 'config';
import axiosClient from 'config/axios';
import { SuccessResponse } from 'core/http/response';
import {
    Ics2AmendmentSummary,
    Ics2CustomsRequest,
    Ics2Referral,
    Ics2ReferralDraft,
    Ics2ReferralSubmission,
    Ics2ReferralSubmitRequest,
} from './types';

const declarationUrl = (declarationId: string) => `${config.declarationsUrl}/eu/ics2/ens/declarations/${declarationId}`;

const referralDraftUrl = (declarationId: string, notificationId: string, referralId: string) =>
    `${declarationUrl(declarationId)}/customs-requests/${notificationId}/referrals/${referralId}/draft`;

const responsesUrl = (declarationId: string) => `${declarationUrl(declarationId)}/referral-responses`;

export const listIcs2CustomsRequests = (declarationId: string): Promise<Ics2CustomsRequest[]> =>
    axiosClient
        .get<SuccessResponse<Ics2CustomsRequest[]>>(`${declarationUrl(declarationId)}/customs-requests`)
        .then((response) => response.data.payload);

export const saveIcs2ReferralDraft = (
    declarationId: string,
    notificationId: string,
    referralId: string,
    version: number,
    data: Ics2ReferralDraft
): Promise<Ics2Referral> =>
    axiosClient
        .put<SuccessResponse<Ics2Referral>>(referralDraftUrl(declarationId, notificationId, referralId), {
            version,
            data,
        })
        .then((response) => response.data.payload);

export const validateIcs2ReferralResponse = (
    declarationId: string,
    versions: Ics2ReferralSubmitRequest
): Promise<void> =>
    axiosClient
        .post<SuccessResponse<boolean>>(`${responsesUrl(declarationId)}/validate`, versions)
        .then(() => undefined);

export const submitIcs2ReferralResponse = (
    declarationId: string,
    idempotencyKey: string,
    versions: Ics2ReferralSubmitRequest
): Promise<Ics2ReferralSubmission> =>
    axiosClient
        .post<SuccessResponse<Ics2ReferralSubmission>>(responsesUrl(declarationId), versions, {
            headers: { 'X-Idempotency-Key': idempotencyKey },
        })
        .then((response) => response.data.payload);

export const getIcs2ReferralResponseHistory = (declarationId: string): Promise<Ics2ReferralSubmission[]> =>
    axiosClient
        .get<SuccessResponse<Ics2ReferralSubmission[]>>(responsesUrl(declarationId))
        .then((response) => response.data.payload);

export const getIcs2ReferralAmendments = (
    declarationId: string,
    notificationId: string
): Promise<Ics2AmendmentSummary[]> =>
    axiosClient
        .get<SuccessResponse<Ics2AmendmentSummary[]>>(
            `${declarationUrl(declarationId)}/customs-requests/${notificationId}/responses/amendments`
        )
        .then((response) => response.data.payload);
